


















import Vue from 'vue';

import DrawingCanvas from '@/components/DrawingCanvas';
import { openFullscreen, cancelFullscreen } from '@/utilities/fullscreen';
import { Nullable } from '@/types';

export default Vue.extend({
  components: {
    DrawingCanvas,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    signature: {
      type: String,
      default: null,
    },

    /**
     * Where the drawing goes. The installation flow leaves this unset and the drawing lands in the
     * device's own library cache, which the library sync later uploads. A questionnaire has no such
     * sync — its images are Documents on the server — so the service screen passes an uploader and
     * the signature travels the same road as every other photo on the form.
     */
    upload: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      isValid: false,
      blob: null as Nullable<Blob>,
      isSaving: false,
      width: 300,
      height: 300,
    };
  },

  watch: {
    dialog(val) {
      if (val) {
        this.blob = null;
      }
    },
  },

  async mounted() {
    setTimeout(() => this.setDimensions(), 100);
    setTimeout(() => this.setDimensions(), 300);

    if ('orientation' in window.screen) {
      await openFullscreen(this.$refs.viewport);
      window.screen.orientation.lock('portrait-primary');
    }
  },

  methods: {
    setDimensions() {
      const viewport = this.$refs.viewport as HTMLElement;
      const { width, height } = viewport.getBoundingClientRect();

      this.width = width - 20;
      this.height = height - 70;
    },

    onReady({ blob }: { blob: Blob }) {
      this.blob = blob;
    },

    async close() {
      await cancelFullscreen(this.$refs.viewport);
      this.$emit('input', false);
    },

    async sign() {
      if (this.blob) {
        this.isSaving = true;

        const url = this.upload
          ? await this.upload(new File([this.blob], 'handtekening.png', { type: 'image/png' }))
          : await this.$store.dispatch('library/addBlob', { blob: this.blob, type: 'png' });

        this.$emit('update:signature', url);
        this.isSaving = false;
        this.close();
      }
    },
  },
});
